module.exports = __webpack_public_path__ + "static/img/month_1st_prize.7a8da88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/prize/month_1st_prize.png
// module id = UoZz
// module chunks = 1